module.exports = "<svg id=\"Layer_1\" viewBox=\"0 0 9.8 16.5\"><style>.st0{fill:#231f20}</style><path d=\"M1 16.5c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l7.8-7.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-7.8 7.3c-.2.2-.5.3-.7.3z\" class=\"st0\"></path><path d=\"M8.8 9.2c-.2 0-.5-.1-.7-.3L.3 1.7C-.1 1.3-.1.7.2.3c.4-.4 1-.4 1.4-.1l7.8 7.2c.4.4.4 1 .1 1.4-.2.3-.4.4-.7.4z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/wedge.svg
// module id = 322
// module chunks = 1